import React from 'react';
import BulkActionBar from '../../../shared/BulkActionBar';
import ProjectTable from './ProjectTable';
import { STATUS_OPTIONS } from '../constants';

/**
 * Archive section component for ProjectList.
 * 
 * @param {Object} props
 * @param {boolean} props.viewMode
 * @param {boolean} props.isArchiveOpen
 * @param {Function} props.setIsArchiveOpen
 * @param {string} props.archiveSearch
 * @param {Function} props.setArchiveSearch
 * @param {Array} props.selectedProjectIds
 * @param {Function} props.setSelectedProjectIds
 * @param {Array} props.archivedList
 * @param {Function} props.handleBulkStatusChange
 * @param {Function} props.handleBulkDelete
 * @param {Object} props.globalPermissions
 * @param {Array} props.projects - All projects (for count).
 * @param {Object} props.tableProps - Props to pass to ProjectTable.
 */
export default function ProjectArchive({
    viewMode,
    isArchiveOpen,
    setIsArchiveOpen,
    archiveSearch,
    setArchiveSearch,
    selectedProjectIds,
    setSelectedProjectIds,
    archivedList,
    handleBulkStatusChange,
    handleBulkDelete,
    globalPermissions,
    projects,
    tableProps
}) {
    // Only show in list mode
    if (viewMode !== 'list') return null;

    const archivedProjectsCount = projects.filter(p => p.status === 'archived').length;

    return (
        <>
            <div className="archive-divider" style={{ maxWidth: '1200px', margin: '20px auto 0 auto' }}>
                <button className="archive-toggle-btn" onClick={() => setIsArchiveOpen(!isArchiveOpen)}>
                    {isArchiveOpen ? '🔼 Archiv ausblenden' : `🔽 Archiv anzeigen (${archivedProjectsCount})`}
                </button>
            </div>

            {isArchiveOpen && (
                <div className="archive-section" style={{ maxWidth: '1200px', margin: '20px auto 0 auto' }}>
                    <div className="archive-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <h3 style={{ margin: 0 }}>📦 Archivierte Projekte</h3>
                        <input
                            className="search-input"
                            style={{ width: '100%', maxWidth: '300px', height: '40px', margin: 0, paddingLeft: '12px', borderRadius: '8px', border: '1px solid #d1d5db', boxSizing: 'border-box' }}
                            placeholder="Im Archiv suchen..."
                            value={archiveSearch}
                            onChange={e => setArchiveSearch(e.target.value)}
                        />
                    </div>
                    {selectedProjectIds.length > 0 && selectedProjectIds.some(id => archivedList.some(p => p.id === id)) && (
                        <div style={{ maxWidth: '1200px', margin: '10px auto', padding: '0 16px', boxSizing: 'border-box' }}>
                            <BulkActionBar 
                                selectedCount={selectedProjectIds.filter(id => archivedList.some(p => p.id === id)).length}
                                onClearSelection={() => setSelectedProjectIds(prev => prev.filter(id => !archivedList.some(p => p.id === id)))}
                                hideSelectionText={true}
                                actions={[
                                    globalPermissions.delete_projects && {
                                        label: `${selectedProjectIds.filter(id => archivedList.some(p => p.id === id)).length} Löschen`,
                                        icon: '🗑️',
                                        variant: 'danger',
                                        onClick: handleBulkDelete
                                    },
                                    {
                                        render: () => (
                                            <div style={{ position: 'relative', minWidth: '160px' }}>
                                                <div 
                                                    className="btn-bulk-action secondary" 
                                                    style={{ 
                                                        height: '34px', 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'space-between',
                                                        padding: '0 12px',
                                                        pointerEvents: 'none',
                                                        boxSizing: 'border-box'
                                                    }}
                                                >
                                                    <span style={{ fontSize: '13px', fontWeight: '500' }}>Status ändern...</span>
                                                    <span style={{ fontSize: '10px', color: '#64748b' }}>▼</span>
                                                </div>
                                                <select 
                                                    key="status-select-archive"
                                                    onChange={(e) => e.target.value && handleBulkStatusChange(e.target.value)} 
                                                    style={{ 
                                                        position: 'absolute', 
                                                        top: 0, 
                                                        left: 0, 
                                                        width: '100%', 
                                                        height: '100%', 
                                                        opacity: 0, 
                                                        cursor: 'pointer' 
                                                    }}
                                                >
                                                    <option value="">Status ändern...</option>
                                                    {STATUS_OPTIONS.filter(opt => opt.value !== 'deleted').map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                                </select>
                                            </div>
                                        )
                                    }
                                ].filter(Boolean)}
                            />
                        </div>
                    )}
                    <ProjectTable 
                        list={archivedList}
                        showBulk={true}
                        globalPermissions={globalPermissions}
                        selectedProjectIds={selectedProjectIds}
                        setSelectedProjectIds={setSelectedProjectIds}
                        {...tableProps}
                    />
                </div>
            )}
        </>
    );
}
